import { render, staticRenderFns } from "./SecuredDisclaimer.vue?vue&type=template&id=513e0926"
import script from "./SecuredDisclaimer.vue?vue&type=script&lang=ts"
export * from "./SecuredDisclaimer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports